<template>
    <v-btn
        class="mx-2"
        fab
        dark
        x-small
        color="green lighten-1"
        @click="$emit('step', $event)"
    >
        <v-icon dark>
            mdi-file-document-edit
        </v-icon>
    </v-btn>
</template>

<script>
export default {
    name: 'EditButton',
}
</script>


// WEBPACK FOOTER //
// src/components/customwidgets/EditButton.vue